import React, { Fragment, useEffect, useState } from "react";
import { isNil } from "ramda";
import Skeleton from "@mui/material/Skeleton";

import FallbackImage from "./FallbackImage";

const Image = ({
  alt,
  height = 150,
  width = 150,
  objectFit = "contain",
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const handleLoad = e => {
    setLoaded(true);
    setError(false);
  };
  const handleError = e => {
    setLoaded(false);
    setError(true);
  };

  useEffect(() => {
    if (isNil(props.src)) {
      setError(true);
    }
  }, [props.src]);

  return (
    <Fragment>
      {!loaded && !error && (
        <Skeleton
          variant="rectangular"
          style={{ borderRadius: 20 }}
          height={height}
          width={width}
        />
      )}
      {error && (
        <FallbackImage
          height={height}
          width={width}
          className={props.className}
        />
      )}
      <img
        style={{
          display: loaded ? "initial" : "none",
          borderRadius: 20,
          objectFit: objectFit,
        }}
        onLoad={handleLoad}
        onError={handleError}
        alt={loaded ? alt : ""}
        height={loaded ? height : 0}
        width={loaded ? width : 0}
        {...props}
      />
    </Fragment>
  );
};

export default Image;
